export default "__VITE_ASSET__C1E2qLNo__"